import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import axios from "axios";
import { API, useAuth } from "../App";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const { token } = useAuth();
  const [status, setStatus] = useState("checking");
  const [attempts, setAttempts] = useState(0);
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    if (!sessionId || attempts >= 5) return;
    const poll = async () => {
      try {
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const res = await axios.get(`${API}/payments/status/${sessionId}`, { headers, withCredentials: true });
        if (res.data.payment_status === "paid") {
          setStatus("success");
        } else if (res.data.status === "expired") {
          setStatus("expired");
        } else {
          setAttempts(a => a + 1);
          setTimeout(poll, 2000);
        }
      } catch {
        setStatus("error");
      }
    };
    poll();
  }, [sessionId, token, attempts]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-8">
      <Card className="w-full max-w-md">
        <CardContent className="p-8 text-center space-y-4">
          {status === "checking" && (
            <>
              <Loader2 className="w-16 h-16 text-emerald-500 animate-spin mx-auto" />
              <h2 className="text-xl font-bold">Verificando pago...</h2>
              <p className="text-slate-500">Estamos confirmando tu pago con Stripe</p>
            </>
          )}
          {status === "success" && (
            <>
              <CheckCircle2 className="w-16 h-16 text-emerald-500 mx-auto" />
              <h2 className="text-xl font-bold text-emerald-700">Pago Exitoso</h2>
              <p className="text-slate-500">Tu plan ha sido activado correctamente</p>
              <Link to="/dashboard"><Button className="mt-4 bg-emerald-600 hover:bg-emerald-700" data-testid="go-dashboard-btn">Ir al Dashboard</Button></Link>
            </>
          )}
          {(status === "error" || status === "expired") && (
            <>
              <XCircle className="w-16 h-16 text-red-500 mx-auto" />
              <h2 className="text-xl font-bold text-red-700">{status === "expired" ? "Sesión Expirada" : "Error en el Pago"}</h2>
              <p className="text-slate-500">No pudimos verificar tu pago. Contacta a soporte.</p>
              <Link to="/billing"><Button variant="outline" className="mt-4" data-testid="retry-payment-btn">Volver a Planes</Button></Link>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSuccess;
